import {useLocation, useParams} from 'react-router-dom';

import {useNavigate} from 'shared/web';

import {OnlineOfferAlternative} from '../api/types/onlineOfferAlternativesTypes';
import {queryParams} from '../consts/queryParams';
import {useGetOnlineOfferData} from './useGetOnlineOfferData';

/**
 * Which alternative the offer page shows. `?alternative=B` shows B; no param, or the letter of the
 * applied alternative, shows the deal vehicle itself. An unknown or withdrawn letter falls back to
 * the deal vehicle too, so a stale link never breaks the page. The URL keeps every other param.
 */
export function useViewedAlternative() {
  const {offerAlternatives} = useGetOnlineOfferData();
  const params = useParams<{offerId: string}>();
  const location = useLocation();
  const navigate = useNavigate();

  const alternatives = offerAlternatives?.alternatives ?? [];
  const letter = new URLSearchParams(location.search).get(queryParams.ALTERNATIVE);
  const viewedAlternative =
    alternatives.find((alternative) => alternative.letter === letter && !alternative.isApplied) ??
    null;
  const activeAlternative =
    viewedAlternative ?? alternatives.find((alternative) => alternative.isApplied) ?? null;

  const viewAlternative = (alternative: OnlineOfferAlternative) => {
    const search = new URLSearchParams(location.search);
    if (alternative.isApplied) {
      search.delete(queryParams.ALTERNATIVE);
    } else {
      search.set(queryParams.ALTERNATIVE, alternative.letter);
    }
    navigate({pathname: `/${params.offerId}`, search: search.toString()});
  };

  return {viewedAlternative, activeAlternative, viewAlternative};
}
